var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V10.5925C13.5 10.7366 13.4378 10.8738 13.3293 10.9688L10.5778 13.3763C10.4866 13.456 10.3696 13.5 10.2485 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V4C2.5 3.17157 3.17157 2.5 4 2.5ZM4 15C2.34315 15 1 13.6569 1 12V4C1 2.34315 2.34315 1 4 1H12C13.6569 1 15 2.34315 15 4V10.5925C15 11.1692 14.751 11.7178 14.317 12.0976L11.5655 14.5052C11.201 14.8242 10.733 15 10.2485 15H4ZM4.5 6.5C4.5 6.08579 4.83579 5.75 5.25 5.75H10.75C11.1642 5.75 11.5 6.08579 11.5 6.5C11.5 6.91421 11.1642 7.25 10.75 7.25H5.25C4.83579 7.25 4.5 6.91421 4.5 6.5ZM5.25 8.75C4.83579 8.75 4.5 9.08579 4.5 9.5C4.5 9.91421 4.83579 10.25 5.25 10.25H8.75C9.16421 10.25 9.5 9.91421 9.5 9.5C9.5 9.08579 9.16421 8.75 8.75 8.75H5.25Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.9d94aa7fa6c3609c99c05bc54bb366f3.svg";
export { ForwardRef as ReactComponent };